export default __webpack_public_path__ + "static/media/invoicelogonew.d8464f62.png";